<script>
import Vue from 'vue'
import { Notifications } from '@/api/notification'
import { mapGetters } from 'vuex'
const notifications = Vue.observable(new Notifications(Vue.prototype.$isSupported))

export default {
    name: 'NotificationAlert',
    data() {
        return {
            close: false,
        }
    },
    computed: {
        ...mapGetters(['lgDevice', 'smDevice', 'xxlUp', 'size']),
        notifications: () => notifications,
        isAllowed() {
            return this.notifications.notificationsAllowed
        },
        supportedPush() {
            return this.notifications.supportedPush
        },
        allowedForUser() {
            return (
                this.$user.model.notification_settings.canteen_push ||
                this.$user.model.notification_settings.delivery_push
            )
        },
        needToShow() {
            return (
                !this.close &&
                this.$user.isLoggedIn &&
                this.supportedPush &&
                this.allowedForUser &&
                ['denied', 'default'].indexOf(Notification.permission) > -1
            )
        },
    },

    methods: {
        allow() {
            this.notifications.register().then(() => {
                this.$store.dispatch('toastInfo', {
                    title: this.$t('base.success'),
                    text: this.$t('profile.notification_info'),
                    button: {
                        to: { name: 'profile-notifications' },
                        label: this.$t('profile.pages.preferences'),
                        $router: this.$router,
                    },
                })
                this.closeForNow()
            })
        },
        closeForNow() {
            this.close = true
        },
    },
}
</script>

<template lang="pug">
transition(name="alert")
    .notification-alert.alert-wrapper(v-if="needToShow")
        .alert.alert-info.d-flex.align-items-center.flex-wrap.justify-content-lg-center.mb-0.mb-lg-5.mt-8.mt-lg-0
            .d-flex.align-items-center(:class="{'w-100': smDevice}")
                icon.mr-4.mr-lg-2(icon="fa-solid fa-bell"  size="lg")
                span.line-1 {{$t('alerts.notification')}}
                button.btn.btn-link.link-white.ml-auto.pl-2(v-if="smDevice" @click="closeForNow")
                    icon(icon="fa-solid fa-times")
            .d-flex.align-items-center.ml-lg-auto.ml-xxl-0.pr-xxl-6(:class="{'w-100 justify-content-between justify-content-lg-start mt-3': smDevice, 'position-absolute right-0': xxlUp }")
                router-link.btn.btn-xs.btn-info-light.ml-lg-6.text-white(:class="{'btn-block mt-0': smDevice}" :to="{name: 'profile-notifications'}") {{$t('base.settings')}}
                button.btn.btn-xs.btn-info-light.mx-3.mx-lg-6.text-white(@click="allow" :class="{'btn-block mt-0': smDevice}") {{$t('base.allow')}}
                button.btn.btn-link.link-white.ml-auto(v-if="lgDevice" @click="closeForNow")
                    icon(icon="fa-solid fa-times")
</template>
